import React from 'react';
import BookingCard from './BookingCard';
import { useSelector } from 'react-redux';

export default function Table() {
  const booking = useSelector((state) => state.booking) || [];
  return (
    <div className="table-container">
      {booking.length > 0 && (
        <table className="booking-table">
          <thead className="bg-gray-100/50">
            <tr className="text-black text-left">
              <th>Destination From</th>
              <th>Destination To</th>
              <th className="text-center">Journey Date</th>
              <th className="text-center">Guests</th>
              <th className="text-center">Class</th>
              <th className="text-center">Delete</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
            {booking &&
              booking?.map((bookingInfo) => (
                <BookingCard key={bookingInfo.id} bookingInfo={bookingInfo} />
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
